package com.appsyde.contract.recommended

/**
 * État cognitif minimal pour le calcul de l'action recommandée (contract).
 * Utilisé côté front (réactivité) et back (persistence) pour garantir le même résultat.
 */
data class RecommendedActionState(
    val intent: String?,
    val detected: Map<String, String>,
    val missing: Set<String>,
    val toConfirm: Set<String>
)
